import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SignedComponent } from './signed.component'

@NgModule({
    imports: [CommonModule],
    declarations: [SignedComponent],
})
export class SignedModule {}